"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyFactory = void 0;
function propertyFactory(fromString) {
    function define(property, config = { required: false }) {
        return (env) => {
            const value = env[property];
            if (!value) {
                if (config.required === true) {
                    throw new Error(`Missing required property ${property}`);
                }
                else {
                    return config.defaultValue;
                }
            }
            try {
                return fromString(value);
            }
            catch (err) {
                if (err instanceof Error) {
                    throw new Error(`Invalid value for property ${property}: ${value}. ` + err.message);
                }
                throw err;
            }
        };
    }
    return define;
}
exports.propertyFactory = propertyFactory;
//# sourceMappingURL=property-factory.js.map